module.exports = __webpack_public_path__ + "static/media/main idea.3df946f8.mp3";